import { useLocation, useNavigate } from "react-router-dom";

import Button from "components/Button";
import { ModalSections } from "v2/components/billing/modals";
import SubmitButton from "components/SubmitButton";

import { ApiKeysInputName } from "v2/api-key-management/routes/ApiKeysDataRoute";


export default function DeleteApiKeyConfirmationModalContent() {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as { apiKey: string };

  return (
    <>
      <ModalSections>
        <div>Are you sure you want to delete your API key?</div>

        <div>Once the API key is deleted you won't be able to use that for scraping anymore.</div>
      </ModalSections>
      <div className="flex justify-between gap-x-4 items-center">
        <SubmitButton
          text="Delete API Key"
          className="button button-primary destructive"
          size="SM"
          name={ ApiKeysInputName.delete_api_key }
          value={ state.apiKey }
        />
        <Button text="Cancel" className="button button-secondary" size="SM" onClick={ () => navigate(-1) }/>
      </div>
    </>
  );
};
